import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import '../Work.css';
import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import mascot from "../../assets/Images/progress/mascot.jpg";
import mascot2 from "../../assets/Images/progress/3d2.png";



import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";



import Slideshow from "../../assets/Slideshow/Slideshow"; 

const WorkMascot = () => {
    const navigate = useNavigate();

    const images = [mascot, mascot2];

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Mascot for the clients</h1>
                <p>Still in progress</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-mascot">
                    <div className="content-work-mascot-text">
                        <h2>Why Mascots?</h2>
                        <p>
                            The reason why I wanted to create a mascot for our clients was because, during the presentation one of my teachers asked
                            if we could have a mascot for our client project. I understand the value of having a mascot, with a mascot we as a group
                            can tie our cat meme theme and the pixel playground. 
                        </p>
                        <h2>Feedback?</h2>
                        <p>
                            I was given recommendation and feedback from Josh to ask to our client before pursuing making this, I gave this idea to Josh
                            that our studio could try make a mascot since we also receive a recommendation from Jan during our presentation that we could
                            use a mascot for the Pixel Playground. I still need to make a concept, after the concepting is done I will try asking our client
                            if this could work then ask the stakeholder Josh and Jan, if it got approved then I will begin making the mascot for the Pixel Playground.
                        </p>
                        
                    </div>

                    <div className="content-work-mascot-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default WorkMascot;